import { postApi } from "../../../shared/api/postApi"
import { ordenarPorNombre } from "../../../shared/utils/funciones"
import { conCacheSesion, invalidarCatalogosTras } from "../../../shared/api/cacheSesion"
import type { ApiResult } from "../../../shared/types/common.types"
import type {
    SedeCrearRequest,
    SedeCrearResult,
    SedesBuscarRequest,
    SedesBuscarResult,
    SedeDeleteRequest,
    SedeMostrarRequest,
    SedeMostrarResult,
    SedeEditarRequest,
    SedesPorCompaniaRequest,
    SedesPorCompaniaResult,
} from "../types/sedes.types"

// Capa de datos del módulo `sedes`. Contratos de respuesta preservados 1:1
// (mismos campos y valores vacíos que la versión con try/catch manual).
// El token viaja en el cuerpo (dataPOST.token) — contrato de este backend.

export const sedeCrear = (dataPOST: SedeCrearRequest): Promise<SedeCrearResult | undefined> =>
    invalidarCatalogosTras(postApi("api/sede/AgregarSede", dataPOST, (d) => ({ idSede: d.idSede }), { idSede: "" }))

export const sedesBuscar = (dataPOST: SedesBuscarRequest): Promise<SedesBuscarResult | undefined> =>
    postApi("api/sede/BuscarSede", dataPOST, (d) => ({ sedes: d.resultado }), { sedes: [] })

export const sedeDelete = (dataPOST: SedeDeleteRequest): Promise<ApiResult | undefined> =>
    invalidarCatalogosTras(postApi("api/sede/EliminarSede", dataPOST))

export const sedeMostrar = (dataPOST: SedeMostrarRequest): Promise<SedeMostrarResult | undefined> =>
    postApi("api/sede/MostrarSede", dataPOST, (d) => ({ sede: d.resultado }), { sede: null })

export const sedeEditar = (dataPOST: SedeEditarRequest): Promise<ApiResult | undefined> =>
    invalidarCatalogosTras(postApi("api/sede/ActualizarSede", dataPOST))

// Esta api funciona en usuario master. Las sedes de una sucursal son estables durante la
// sesión -> se cachean por token+compania para no re-consultar en cada navegación.
export const sedesPorCompania = (dataPOST: SedesPorCompaniaRequest): Promise<SedesPorCompaniaResult | undefined> =>
    conCacheSesion(
        // MULTI-SEDE ÁRBOL: la clave incluye `comp_pad` porque `compania='T'` (árbol) es
        // el MISMO valor para todos los padres; sin él, distintos árboles compartirían caché.
        `sedes:${(dataPOST as any)?.token}:${(dataPOST as any)?.compania}:${(dataPOST as any)?.comp_pad ?? ""}`,
        () => postApi("api/sede/ListaSede", dataPOST, (d) => ({ sedes: ordenarPorNombre(d.resultado) }), { sedes: [] }),
        (v) => (v as any)?.status === 1,
    )
